<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-05-31 09:13:11
 -->
<template>
  <div class="container bg-white">
    <div class="container-flex">
      <div class="recharge-details">
        <div class="details-icon">
          <img :src="details.img" alt="" class="wh100" />
        </div>

        <div class="change-money" v-if="details.money != '--'">{{ details.money }}<span>元</span></div>
        <div class="money-text">{{ details.text }}</div>
        <div class="pi-divider" style="margin: 0 0.6rem"></div>
        <div
          class="details-box"
          v-for="(item, index) in details.info"
          :key="index"
        >
          <div class="name">{{ item.name }}</div>
          <div class="flex">{{ item.value }}</div>
        </div>
        <view class="error-tips" v-if="detailsData.orderType == 2 && detailsData.orderStatus == 6 && detailsData.requestRefundAmount != detailsData.transactionAmount">未退款金额已返回到账户中，有问题请联系运营商！</view>
    
      </div>
    </div>
  </div>
</template>
<script>
import { getTransactionDetail } from "../../common/api";
import { formatOrderStatusDesc } from "../../common/old/public/filters";

export default {
  name: "my-recharge-details",
  data() {
    return {
      businessOrderNo: this.$route.query.businessOrderNo || 1,
      details: {
        money: null,
        text: null,
        img: require("../../assets/img/change-details.png"),
        info: [],
      },
      orderNo: "",
      detailsData: {}
    };
  },
  methods: {
    getRechargeDetails() {
      getTransactionDetail({
        orderNo: this.$route.query.orderNo,
      })
        .then((data) => {
          if (data.status === this.$config.ajaxStatus2) {
            this.detailsData = data.data[0] || {}
            if (data.data[0].orderType === 0) {
              document.title = "充值详情";
              this.details.img = require("../../assets/img/change-details.png");
              this.details.text = data.data[0].orderStatusDesc;
              this.details.money = data.data[0].transactionAmount;
              this.details.info = [];
              this.details.info.push({
                name: "充值时间",
                value: data.data[0].transactionTime,
              });
              this.details.info.push({
                name: "充值方式",
                value: data.data[0].rechargeMethodDesc,
              });
              this.details.info.push({
                name: "充值单号",
                value: data.data[0].transactionId,
              });
              this.details.info.push({
                name: "交易单号",
                value: data.data[0].orderNo,
              });
            } else if (
              data.data[0].orderType === 1 ||
              data.data[0].orderType === 6
            ) {
              document.title = "金额详情";
              this.details.img = require("../../assets/img/change-details.png");
              this.details.text = formatOrderStatusDesc(data.data[0]);
              this.details.money = data.data[0].transactionAmount;
              this.details.info = [];
              this.details.info.push({
                name: "交易单号",
                value: data.data[0].orderNo,
              });
              this.details.info.push({
                name: "交易类型",
                value: data.data[0].orderTypeDesc,
              });
              this.details.info.push({
                name: "交易时间",
                value: data.data[0].transactionTime,
              });
            } else {
              document.title = "退款详情";
              this.details.img = require("../../assets/img/change-details.png");
              this.details.text = formatOrderStatusDesc(data.data[0]);
              this.details.money = data.data[0].orderStatus == 6 ? data.data[0].transactionAmount : '--';
              this.details.info = [];
              this.details.info.push({
                name: "申请金额",
                value: data.data[0].requestRefundAmount,
              });
              this.details.info.push({
                name: "交易单号",
                value: data.data[0].orderNo
                  ? data.data[0].orderNo
                  : this.orderNo,
              });
              let refundMethodDesc =
                data.data[0].refundMethodDesc || "原路返回";
              
              this.details.info.push({
                name: "申请时间",
                value: data.data[0].createTime,
              });
              if (data.data[0].orderStatus === 7) {
                let remark = data.data[0].remark
                  ? data.data[0].remark
                  : data.data[0].auditResult;
                this.details.info.push({
                  name: "拒绝原因",
                  value: remark,
                });
              } else if (data.data[0].orderStatus === 6) {
                this.details.info.push({
                  name: "退款时间",
                  value: data.data[0].transactionTime,
                });
                this.details.info.push({
                  name: "退款方式",
                  value: refundMethodDesc,
                });
              } else {
                this.details.info.push({
                  name: "退款方式",
                  value: refundMethodDesc,
                });
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    this.getRechargeDetails();
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.recharge-details {
  padding-top: 0.8rem;
  .details-icon {
    width: 2.56rem;
    height: 3.54rem;
    margin: auto;
  }
  .change-money {
    font-size: 0.72rem;
    line-height: 1.12rem;
    text-align: center;
    font-weight: bold;
    color: @main-color;
    span {
      font-size: 0.7rem;
      font-weight: normal;
    }
  }
  .money-text {
    text-align: center;
    margin-top: 0.06rem;
    font-size: 0.32rem;
    color: #5a5b5d;
    margin-bottom: 0.36rem;
  }
  .details-box {
    margin-top: 0.2rem;
    display: flex;
    padding: 0.2rem 0.6rem;
    font-size: 0.28rem;
    align-items: baseline;
    .name {
      color: #999;
      width: 1.7rem;
    }
    .flex {
      flex: 1;
      text-align: left;
      color: #000;
      word-break: break-all;
    }
  }
  .details-box:first-child {
    margin-top: 0;
  }
}
</style>
